import React, { useRef } from 'react';
import 'react-spring-bottom-sheet/dist/style.css';
import { BottomSheetProps } from 'react-spring-bottom-sheet';
import { StyledSheetContainer, StyledBottomSheet } from './style';
import useWindowsSize from 'hooks/useWindowsSize';
import { defaultFooterRenderer } from './elements';
import { useActionSheet } from './useActionSheet';

type ActionSheetType = BottomSheetProps & {
  onApply?: () => void;
  onDefault?: () => void;
  loading?: boolean;
  hasFooter?: boolean;
  id?: string;
};

const ActionSheet: React.FC<ActionSheetType> = ({
  children,
  onApply,
  onDefault,
  loading,
  hasFooter = true,
  id = 'user',
  open,
  onDismiss,
  ...rest
}) => {
  const [, height] = useWindowsSize();
  const bottomSheetRef = useRef(null);
  const { isOpenActionSheet, handleDefault, handleApply, handleDismiss } =
    useActionSheet(id, open, onDismiss, onApply, onDefault);

  return (
    <StyledBottomSheet
      footer={
        hasFooter
          ? defaultFooterRenderer(handleDefault, handleApply, loading)
          : false
      }
      initialFocusRef={false}
      maxHeight={height / 1.5}
      scrollLocking={false}
      ref={bottomSheetRef}
      {...rest}
      onDismiss={handleDismiss}
      open={!!isOpenActionSheet && isOpenActionSheet === id}
    >
      <StyledSheetContainer data-cy="action-sheet">
        {children}
      </StyledSheetContainer>
    </StyledBottomSheet>
  );
};

export default ActionSheet;
